import React, { Component } from 'react';
import { HeartIcon, DollarSignIcon, CheckCircleIcon, UsersIcon } from 'lucide-react';
const benefits = [{
  icon: HeartIcon,
  text: 'Local roots, family values'
}, {
  icon: DollarSignIcon,
  text: 'Transparent pricing — no surprise fees'
}, {
  icon: CheckCircleIcon,
  text: 'Dependable service — courteous drivers and on-time pickups'
}, {
  icon: UsersIcon,
  text: 'Community focus — supporting local events and neighborhood cleanups'
}];
export function WhyChooseUs() {
  return <section className="py-20 bg-gradient-to-b from-gray-100 to-white" data-id="element-195">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-196">
        {/* Why Choose Us Header */}
        <div className="text-center mb-12" data-id="element-197">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8" data-id="element-198">
            Why Choose Sam's Disposal?
          </h2>
          {/* Benefits Checklist */}
          <div className="max-w-3xl mx-auto space-y-6" data-id="element-199">
            {benefits.map((benefit, index) => {
            const IconComponent = benefit.icon;
            return <div key={index} className="flex items-start gap-4 text-left bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-all border-l-4 border-[#E41C1C]" data-id="element-200">
                  <div className="flex-shrink-0 w-12 h-12 bg-[#E41C1C] rounded-full flex items-center justify-center" data-id="element-201">
                    <IconComponent className="w-6 h-6 text-white" data-id="element-202" />
                  </div>
                  <p className="text-lg text-gray-900 font-semibold leading-relaxed pt-2" data-id="element-203">
                    {benefit.text}
                  </p>
                </div>;
          })}
          </div>
        </div>
        {/* Mission and Vision Panels */}
        <div className="grid md:grid-cols-2 gap-8 mt-16" data-id="element-204">
          {/* Mission Statement */}
          <div className="bg-[#E41C1C] rounded-lg p-8 shadow-xl" data-id="element-205">
            <h3 className="text-2xl font-bold text-white mb-4 text-center" data-id="element-206">
              Our Mission
            </h3>
            <p className="text-white leading-relaxed text-center font-medium" data-id="element-207">
              At Sam's Disposal, we work hard every day to provide honest,
              reliable waste services our community can count on. Built on
              integrity, trust, and loyalty, we're committed to supporting other
              local businesses and creating job opportunities for our neighbors.
              We take pride in serving our community with the same dedication
              and values that have guided our family from the start.
            </p>
          </div>
          {/* Vision Statement */}
          <div className="bg-gray-900 rounded-lg p-8 shadow-xl" data-id="element-208">
            <h3 className="text-2xl font-bold text-white mb-4 text-center" data-id="element-209">
              Our Vision
            </h3>
            <p className="text-white leading-relaxed text-center font-medium" data-id="element-210">
              To build a cleaner, stronger community through hard work, honest
              service, and lasting relationships built on trust.
            </p>
          </div>
        </div>
      </div>
    </section>;
}